import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {catchError, finalize} from 'rxjs/operators';
import {SpinnerService} from '@app/core/services/spinner.service';
import {AuthService} from '@app/features/auth/services/auth.service';
import {ErrorManagerService} from '@app/core/services/error-manager.service';

@Injectable()
export class HttpClientInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private spinner: SpinnerService,
    private errorManager: ErrorManagerService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.spinner.show();
    const req = this.authService.isLoggedIn ? this.addTokenToRequest(request) : request;
    return next.handle(req).pipe(
      finalize(() => this.spinner.hide()),
      catchError((err: HttpErrorResponse) => this.handleAuthError(err))
    );
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    if (err.status === 401) {
      // Token scaduto o mancante — delega il re-login all'AuthService
      // che gestisce internamente race conditions, backoff e circuit breaker
      console.warn(`[INTERCEPTOR] 401 su ${err.url} — richiesta autenticazione`);
      this.authService.checkLogin();
      return of(err.message);
    }

    if (err.status === 403) {
      // Autenticato ma non autorizzato — non ha senso fare re-login
      console.warn(`[INTERCEPTOR] 403 su ${err.url} — utente non autorizzato`);
      this.errorManager.showErrorDialog('Utente non autorizzato');
      return of(err.message);
    }

    if (err.status === 405) {
      console.warn(`[INTERCEPTOR] 405 su ${err.url}`);
      return of(err.message);
    }

    return throwError(() => err);
  }

  private addTokenToRequest(request: HttpRequest<any>): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: this.authService.currentAccessToken,
      }
    });
  }
}
